/**
 * Constant in `px` giving the threshold between small and large screens.
 */

const mediumBreakpoint = 880;

/**
 * Verify if the screen is in small mode, either by taking the
 * configuartion measure or by deciding that the screen is small
 * if smaller than a maximum height
 *
 * @param {boolean} configuration.forcedIsSmallScreenValue - When defined, overwrite the
 *   computation result in `isInSmallScreen`
 */
export function isInSmallScreen({ configuration } = {}) {
	if (configuration?.forcedIsSmallScreenValue !== undefined) {
		return configuration.forcedIsSmallScreenValue;
	}

	return document.body.offsetHeight < mediumBreakpoint;
}
